// extracted by mini-css-extract-plugin
module.exports = {"discountText":"DiscountCard-module__discountText___Eys5B"};